import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  ProductVariantTranslationInput
} from "../../types/globalTypes";
import TranslationsProductVariantPage, {
  fieldNames
} from "../components/TranslationsProductVariantPage";
import { TypedUpdateProductVariantTranslations } from "../mutations";
import { TypedProductVariantTranslationDetails } from "../queries";
import { UpdateProductVariantTranslations } from "../types/UpdateProductVariantTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsProductVariantQueryParams {
  activeField: string;
}
export interface TranslationsProductVariantProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsProductVariantQueryParams;
}

const TranslationsProductVariant: React.FC<TranslationsProductVariantProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateProductVariantTranslations) => {
    if (data.productVariantTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedProductVariantTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {productVariantTranslations => (
        <TypedUpdateProductVariantTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: ProductVariantTranslationInput = {};
              if (field === fieldNames.describe) {
                input.describe = data;
              } else if (field === fieldNames.fullDescription) {
                input.fullDescription = data;
              } else if (field === fieldNames.shortDescription) {
                input.shortDescription = data;
              } else if (field === fieldNames.name) {
                input.name = data;
              } else if (field === fieldNames.skuName) {
                input.skuName = data;
              } else if (field === fieldNames.USP) {
                input.USP = data;
              } else if (field === fieldNames.seoDescription) {
                input.seoDescription = data;
              } else if (field === fieldNames.seoTitle) {
                input.seoTitle = data;
              } else if (field === fieldNames.seoKeyword) {
                input.seoKeyword = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsProductVariantPage
                activeField={params.activeField}
                disabled={
                  productVariantTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.products, id)
                  )
                }
                onSubmit={handleSubmit}
                variant={maybe(
                  () => productVariantTranslations.data.productVariant
                )}
              />
            );
          }}
        </TypedUpdateProductVariantTranslations>
      )}
    </TypedProductVariantTranslationDetails>
  );
};
TranslationsProductVariant.displayName = "TranslationsProductVariant";
export default TranslationsProductVariant;
